import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=4f2e7962&"
import script from "./Wizard.vue?vue&type=script&lang=ts&"
export * from "./Wizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2e7962')) {
      api.createRecord('4f2e7962', component.options)
    } else {
      api.reload('4f2e7962', component.options)
    }
    module.hot.accept("./Wizard.vue?vue&type=template&id=4f2e7962&", function () {
      api.rerender('4f2e7962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/Wizard.vue"
export default component.exports